import { Button } from '@mantine/core';

interface ErrorFallbackProp {
  location: string;
  eventId: string;
  resetError: () => void;
}

const ErrorFallback = ({
  location = 'La Caisse',
  eventId,
  resetError,
}: ErrorFallbackProp) => {
  return (
    <div className="w-full h-full flex flex-col justify-center items-center gap-4">
      <h2 className="text-2xl">Oops! Une erreur est survenue!</h2>
      <p className="text-xl">
        Veuillez réessayer en cliquant sur le bouton si dessu.
      </p>
      <Button onClick={resetError}>Réessayer</Button>
      <p className="text-xl">Si l'erreur persiste, contactez-nous.</p>
      <p className="mt-12">
        Details de l'erreur: {eventId}@{location}
      </p>
    </div>
  );
};

const errorFallback = (
  location: string,
  eventId: string,
  resetError: () => void,
) => (
  <ErrorFallback
    location={location}
    eventId={eventId}
    resetError={resetError}
  />
);

export default errorFallback;
